import { atBqnTarget } from "common/api";

export const getMetricsAttributes = (login) => {
  return {
    "MAX-Mbps": {
        field: "MAX-Mbps",
        label: "MAX-Mbps",
        labelForModal: "Percentage of rate limit",
        units: "Mbps",
        legend: "Max speed last 24h",
        tooltip:
          "maximum speed in Mbps during the previous 24 hours or since last subs-id/policy change",
        percentage: true,
        labelThreshold: "% of lim",
    },
    "MEAN-Mbps": {
      field: "MEAN-Mbps",
      label: "MEAN-Mbps",
      units: "Mbps",
      legend: "Mean speed last 24h",
      tooltip:
        "Mean speed in Mbps during the previous 24 hours or since last subs-id/policy change",
      unit: "%",
    },
    "SUBS-ACTIVE": {
      field: "SUBS-ACTIVE",
      label: "SUBS-ACTIVE",
      inverted: true,
      units: "active subscribers",
      legend: "active subscribers",
      tooltip: "Active subscribers",
      unit: "%",
    },
    "RTT-80%-ms": {
        field: "RTT-P80-ms",
        label: "RTT-P80-ms",
        inverted: true,
        units: "ms",
        legend: login.isPlatform("cambium")
          ? "Latency from QoE"
          : "Latency from bqn",
        tooltip:
          "Moving average of latency, in milliseconds. Each measurement aggregated in the moving average is the mean of all downlink RTT minimum latency samples in 10 minutes, measured in 1-second intervals, during active downloads (Mean-Min). If downlink, latency from this node to subs, if uplink, latency from this node to Internet server",
        labelThreshold: "ms",
    },
    "RTT-P80-ms": {
        field: "RTT-P80-ms",
        label: "RTT-P80-ms",
        inverted: true,
        units: "ms",
        legend: login.isPlatform("cambium")
          ? "Latency from QoE"
          : "Latency from bqn",
        tooltip:
          "Moving average of latency, in milliseconds. Each measurement aggregated in the moving average is the mean of all downlink RTT minimum latency samples in 10 minutes, measured in 1-second intervals, during active downloads (Mean-Min). If downlink, latency from this node to subs, if uplink, latency from this node to Internet server",
        labelThreshold: "ms",
    },
    "RTT-MED-ms": {
        field: "RTT-MED-ms",
        label: "RTT-MED-ms",
        inverted: true,
        units: "ms",
        legend: login.isPlatform("cambium")
          ? "Latency from QoE"
          : "Latency from bqn",
        tooltip:
          "Moving average of latency, in milliseconds. Each measurement aggregated in the moving average is the mean of all downlink RTT minimum latency samples in 10 minutes, measured in 1-second intervals, during active downloads (Mean-Min). If downlink, latency from this node to subs, if uplink, latency from this node to Internet server",
        labelThreshold: "ms",
    },
    "RTT-MIN-ms": {
        field: "RTT-MIN-ms",
        label: "RTT-MIN-ms",
        inverted: true,
        units: "ms",
        legend: login.isPlatform("cambium")
          ? "Latency from QoE"
          : "Latency from bqn",
        tooltip:
          "Moving average of latency, in milliseconds. Each measurement aggregated in the moving average is the mean of all downlink RTT minimum latency samples in 10 minutes, measured in 1-second intervals, during active downloads (Mean-Min). If downlink, latency from this node to subs, if uplink, latency from this node to Internet server",
        labelThreshold: "ms",
    },
    "RTT-ms": {
      field: "RTT-ms",
      label: "RTT-ms",
      inverted: true,
      units: "ms",
      legend: login.isPlatform("cambium")
        ? "Latency from QoE"
        : "Latency from bqn",
      tooltip:
        "Moving average of latency, in milliseconds. Each measurement aggregated in the moving average is the mean of all downlink RTT minimum latency samples in 10 minutes, measured in 1-second intervals, during active downloads (Mean-Min). If downlink, latency from this node to subs, if uplink, latency from this node to Internet server",
      labelThreshold: "ms",
    },
    RTX: {
      field: "RTX",
      label: "RTX",
      inverted: true,
      units: "% retransmisions",
      legend: "TCP packet retransmission",
      tooltip:
        "Moving average of the percentage of TCP retransmissions (which reflect packet losses in this direction)",
      percentage: true,
      labelThreshold: "%",
      unit: "%",
    },
    CONGEST: {
      field: "CONGEST",
      label: "CONGESTION",
      tooltip: "Moving average of percentage of traffic suffering congestion",
      inverted: true,
      units: "% of traffic",
      legend: "% traffic under congestion",
      percentage: true,
      labelThreshold: "%",
      unit: "%",
    },
     "MAX-SPEED": {
        field: "MAX-SPEED",
        label: "MAX-SPEED-%",
        inverted: true,
        units: "% of traffic",
        legend: "% traffic sent at max speed",
        tooltip:
          "Moving average of the percentage of traffic sent with a speed close to the maximum",
        percentage: true,
        labelThreshold: "%",
    },
  };
};

// The thresholds of the BQN selected in the header. The BQN is optional: the
// views not asking for one take the thresholds of the whole cluster.
export const getThresholds = (mode, bqnId) => {
  return ifCl
    .run(atBqnTarget("show subscriber metrics-thresholds", mode, bqnId))
    .then((response) => {
      const rows = response.trim("\n").split("\n");
      return rows.reduce((acc, row) => {
        const [metric, value] = row.split(/:\s+/);
        acc[metric] = isNaN(parseFloat(value)) ? value : parseFloat(value);
        return acc;
      }, {});
    });
};

export const thresholdKeyMap = {
  "MAX-Mbps": "max-mbps",
  "RTT-P80-ms": "rtt-p80",
  "RTT-MED-ms": "rtt-med",
  "RTT-MIN-ms": "rtt-min",
  RTX: "rtx",
  "MAX-SPEED": "max-speed",
  CONGEST: "congest",
  "RTT-ms": "rtt-ms",
  "PERCENT-WARNING": "percent-warning",
  "MEAN-Mbps": "mean-mbps",
};

export const metricThresholdMap = {
  "Rtt-Med-Dn": "RTT-MED-ms",
  "Rtt-80%-Dn": "RTT-80%-ms",
  "Rtt-Min-Dn": "RTT-MIN-ms",
};